import initCategorySelect from "./category-handler";
import initImageUploads from "./image-upload-handler";
import initSubmitClaimForm from "./form-handler";

document.addEventListener("DOMContentLoaded", () => {
  initCategorySelect();
  initImageUploads();
  initSubmitClaimForm();
});
